exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.big.el-select[data-v-9c36edf8] {\n  width: 450px;\n}\n.biggest.el-textarea[data-v-9c36edf8] {\n  width: 700px;\n}\n.el-checkbox__label[data-v-9c36edf8] {\n  background-color: transparent;\n}\n.el-form-item__content[data-v-9c36edf8] {\n  line-height: 20px;\n}\n.el-form-item__label[data-v-9c36edf8] {\n  text-align: right;\n  float: left;\n  font-size: 14px;\n  color: #606266;\n  line-height: 20px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.el-form-item[data-v-9c36edf8] {\n  color: #1e0080;\n  font-weight: bold;\n  padding-right: 20px;\n  padding-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9c36edf8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/ViewerJudgment.vue
// module id = WfmC
// module chunks = 1